exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bs-example[data-v-55df3058]{margin:20px}", ""]);

// exports
